import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Logout = (props) => {
  const navigate = useNavigate();

  function logout(e) {
    e.preventDefault();

    // Clear JWT token from localStorage
    localStorage.removeItem('jwt-token');

    // Make API Request
    axios({
      method: 'post',
      url: '/auth/logout',
      withCredentials: true,
    })
      .then(function (res) {
        // Force a full page reload to clear all cached auth state
        window.location.href = '/';
      })
      .catch(function (error) {
        // Even if the API call fails, we've cleared the token so force reload anyway
        console.log('Logout API error:', error);
        window.location.href = '/';
      });
  }

  return (
    <button onClick={logout} className={props.style}>
      Logout
    </button>
  );
};

export default Logout;
